const pages = [
  {
    id: 'home',
    name: 'Home',
    slug: '',
  },
  {
    id: 'aboutus',
    name: 'About Us',
    slug: 'about-us',
  },
]

export default pages
